export default __webpack_public_path__ + "static/media/sports.e9628c78.jpg";